import React, { useEffect } from 'react';
import { Col, Row} from 'react-bootstrap';
import LoginForm from './LoginForm';
import { useNavigate } from 'react-router-dom';
import { useLogin } from '../../context/LoginContext';
import { TopMenu } from '../shared';

function LoginPage() {
    const navigate = useNavigate();
    const { isLoggedIn } = useLogin();
    useEffect(() => {
        if (isLoggedIn) {
            navigate('/home');
        }
    }, [isLoggedIn]);
    return (
        <div className='add-video-bg pleft0 min-h100 pt-0'>
            <Row className='justify-content-center align-items-center '>
               <TopMenu/>
                <Col lg={7} sm={12} className='text-center lms-mascotbg pleft0'>
                    {/* <h1 className='text-center mb-4'><span>Welcome to PMFBY</span> <span>Learning Management System</span></h1> */}
                </Col>
                <Col lg={5} sm={12} >
                    <LoginForm />
                </Col>
            </Row>
        </div>
    );
}

export default LoginPage;
